import { proxy } from "valtio";

export const cryptoStore = proxy<{ cryptoId: string }>({
  cryptoId: "",
});
